import Vue from 'vue';
import Component from 'vue-class-component';
import XTreeMenu from '../../components/left-navigation/XTreeMenu.vue';
import {XTreeItem} from '../../models/NavTreeModel';
import {getTreeChildren} from '../../models/NavTreeModel';



@Component({
    name:'root-el',
  
    props:{
      viewportid:{
      },
      rootlink:{
      },
      currentlink:{
      },
      parentlink:{
      },
      contextpath:{
      },
      activepageid:{
      },
      activepagetitle:{
      },
      ancestors:{
      }

  },
    components:{
        'xtree-menu':XTreeMenu
    }
})
export default class RootEl extends Vue{

viewportid:string;
rootlink:string;
currentlink:string;
parentlink:string;
contextpath:string;
activepageid:string;
activepagetitle:string;
ancestors:string;

hasChilds:boolean=false;


public itemChildren=[];

 computeParentLink():string{
   // console.log("THE PARENT LINK ENTRY: ",this.parentlink);
    let ret:string = this.parentlink?this.parentlink:this.rootlink;
   // console.log("THE PARENT LINK OUT: ",ret);
    return ret;
}
 

      created(){
        /*
      console.log('viewportId:',this.viewportid);
      console.log('rootlink:',this.rootlink);
      console.log('currentLink:',this.currentlink);
      console.log('parentLink:',this.parentlink);
      console.log('contextPath:',this.contextpath);
      console.log('active Pagelink',this.currentlink);
      console.log('active PageID',this.activepageid);
      console.log('active PageTitle',this.activepagetitle);
      console.log('ancestors',this.ancestors);
    */

      getTreeChildren(
        this.contextpath,
        this.viewportid,
        this.rootlink,
        this.parentlink,
        this.currentlink
    )
    .then((children)=>{
   //   console.log("###HIER DIE CHILDREN: ");
        if(children && children.length>0){
            this.hasChilds=true;
            this.itemChildren=children;
            //console.dir(children);
        }
    })
    .fail((jqXHR,textStatus, errorThrown)=>{

    })
      }
}